import React, { useEffect, useState } from "react";
import { Col, Icon, List, Row, Modal } from "antd";
import {
  AttachmentIcon,
  PreviewEyeIcon,
  TrashIcon,
} from "../../common/CustomIcon";
import { getFileType } from "../../common/Common";
import DocumentPreviewCarousel from "../../common/DocumentPrviewCarousal";

// Carousel items can come from different endpoints with different field
// names - fall back across the common ones rather than assuming one shape.
const normalizeCarouselDoc = (doc = {}, index) => ({
  uid:
    doc.id ||
    doc.uid ||
    doc.ack_id ||
    `preview-${index}`,

  name:
    doc.pic_code ||
    doc.fileName ||
    doc.pic_title ||
    "OTHER ATTACHMENT",

  src:
    doc.src ||
    doc.url ||
    doc.file_url ||
    doc.picture_url,

  image_type:
    doc.image_type ||
    doc.type,

  picture_obj: doc.picture_obj,

  ack_id: doc.ack_id,
  pictures_id: doc.id || doc.pictures_id,
  isSaved: !!(doc.id || doc.pictures_id),
  pic_code: doc.pic_code || doc.pic_title,
  pic_title: doc.pic_title || doc.pic_code,
  amount: doc.amount !== undefined ? doc.amount : doc.payment_info?.amount,
});

export const FileList = (props) => {
  const { fileList, handleDelete} = props;
  return (
    <>
    <List
      className="documents-staged-list"
      bordered={false}
      // dataSource={
      //   actionType === "create" ? stagedDocs : [...documents, ...stagedDocs]
      // }
      dataSource={fileList}
      renderItem={(file) => (
        <List.Item
          actions={[
            <Row type="flex" align="middle">
              <Col style={{ height: 33 }} className="blkCenterRight" data-testid="file-trash-button">
                <TrashIcon
                  styling={{ width: "19px", height: "19px" }}
                  // color={hoveredIcon === "trash" ? "#D23B71" : "#576EC1"}
                  color="#576EC1"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDelete([file.ack_id], "modal")}
                />
              </Col>
            </Row>,
          ]}
        >
          {/* Display icon based on file type */}
          <List.Item.Meta
            title={
              <Row type="flex" align="middle" style={{display: "flex", alignItems: "center"}}>
                <Col className="blkCenterLeft" data-testid="file-select-button">
                  <AttachmentIcon color="#1D2540" width="25px" height="33px" />
                </Col>
                <Col
                  style={{ height: 33, fontWeight: 700 }}
                  className="center blkCenterLeft"
                >
                  <span style={{ marginLeft: 8 }}>{file.pic_code}</span>{" "}
                </Col>
                <Col style={{ height: 33 }} className="center blkCenterLeft">
                  {" "}
                  <span style={{ marginLeft: 8 }}>{file.fileName}</span>{" "}
                </Col>
              </Row>
            }
          />
        </List.Item>
      )}
    />
    </>
  );
};

export const FileSelect = (props) => {
  const { file, toggleSelectDocument, selectedDocs } = props;
  const isSelected = selectedDocs?.some((doc) => doc?.ack_id === file?.ack_id);
  return (
    <div
      style={{
        boxSizing: "content-box",
        width: "18px",
        height: "18px",
        border: "3px solid #FFFFFF",
        borderRadius: "2px",
      }}
    >
      <div
        style={{
          width: "18px",
          height: "18px",
          border: "1px solid #7187DA",
          borderRadius: "2px",
          backgroundColor: isSelected ? "#617AD6" : "#FFFFFF",
        }}
        data-testid={`file-select-card-${file?.id || file?.ack_id}`}
        onClick={() => toggleSelectDocument(file.ack_id, file.id)}
      >
        {isSelected && (
          <Icon
            type="check"
            style={{
              color: "#fff",
              fontSize: "14px",
              position: "relative",
              top: "-3px",
              left: "0px",
            }}
          />
        )}
      </div>
    </div>
  );
};

export const FileCard = (props) => {
  const {
    file,
    documents = [],
    selectedDocs,
    toggleSelectDocument,
    setPreviewVisible,
    previewVisible,
    setPreviewFileUrl,
    setPreviewFileType,
    setShow,
    locObj,
    isShipper = false,
    previewDocs = [],
    enableSelection = true,
    onPrint = () => {},
    setIsPODemailModalVisible,
  } = props;
  const [isHovered, setIsHovered] = useState(false);
  const isSelected = selectedDocs?.some(
    (doc) => doc?.ack_id && file?.ack_id && doc.ack_id === file.ack_id
  );
  const fileType = getFileType(file?.src || file?.picture_url);

  // Items + starting slide for the carousel preview. The full `documents` list
  // carries the real doc objects (src, pic_code, image_type) - previewDocs is
  // only a slim { ack_id, pictures_id } list in the order flow, so it can't be
  // the primary source for the carousel.
  const carouselSource = documents?.length
    ? documents
    : locObj?.documents?.length
    ? locObj.documents
    : previewDocs?.length
    ? previewDocs
    : [file];

  // Only show documents that share the exact pic_code of the file that was
  // clicked (e.g. clicking a POD card only carousels through other POD docs).
  const clickedPicCode = file?.pic_code;

  const filteredItems = carouselSource
    .filter(
      (doc) =>
        doc &&
        doc.image_type !== "print" &&
        (!clickedPicCode || doc.pic_code === clickedPicCode)
    )
    .map(normalizeCarouselDoc);

  const clickedItem = file ? normalizeCarouselDoc(file, -1) : null;

  // Make sure the clicked file is always in the carousel, even when it's a
  // staged/unsaved doc that isn't part of the uploaded `documents` list yet.
  const carouselItems =
    clickedItem &&
    !filteredItems.some(
      (item) =>
        (clickedItem.uid && item.uid === clickedItem.uid) ||
        (clickedItem.src && item.src === clickedItem.src)
    )
      ? [clickedItem, ...filteredItems]
      : filteredItems;

  const carouselStartIndex = Math.max(
    0,
    carouselItems.findIndex(
      (item) =>
        (clickedItem?.uid && item.uid === clickedItem.uid) ||
        (clickedItem?.src && item.src === clickedItem.src)
    )
  );

  const closePreview = () => {
    setPreviewVisible && setPreviewVisible(false);
    setPreviewFileUrl && setPreviewFileUrl(null);
    setPreviewFileType && setPreviewFileType(null);
    setIsHovered && setIsHovered(false);
  };

    const [visible, setVisible] = useState(false);

    useEffect(() => {
      if (!previewVisible) {
        setVisible(false);
      }
    }, [previewVisible]);
    

  const fileIcons = {
    pdf: "file-pdf",
    docs: "file-word",
    sheet: "file-excel",
    video: "play-circle",
    default: "file",
  };

  const getFileIcon = (fileType) => fileIcons[fileType] || fileIcons.default;

  const handlePreview = () => {
    try {
      const fileUrl = file.src || file.picture_url;
      setPreviewFileUrl(fileUrl);
      setPreviewFileType(fileType);
      setPreviewVisible(true);
      setVisible(true);
      if (enableSelection) {
        toggleSelectDocument(file.ack_id, file.id, true);
      }
      setShow(false);
    } catch (error) {
      console.error("Error creating object URL:", error);
    }
  };

  return (
    <div
      data-testid="file-card"
      style={{
        width: "56px",
        height: "72px",
        border: isSelected
          ? "4px solid #576EC1"
          : isHovered
          ? "1px solid #7187DA"
          : "1px solid #E6EBF0",
        borderRadius: "4px",
        textAlign: "center",
        position: "relative",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {fileType === "image" ? (
        <img
          src={file?.src || file?.picture_url}
          alt="preview"
          style={{
            width: "48px",
            height: "64px",
            objectFit: "cover",
            opacity: isHovered ? 0.15 : 0.35,
            cursor: "pointer",
          }}
        />
      ) : (
        <Icon
          type={getFileIcon(fileType)}
          style={{
            fontSize: "48px",
            color: "#576EC1",
            cursor: "pointer",
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: isHovered ? 0.15 : 0.35,
          }}
        />
      )}
      {enableSelection && !isShipper && (isSelected || isHovered) && (
        <div
          style={{
            position: "absolute",
            top: isSelected ? -8 : -4,
            left: isSelected ? -8 : -4,
          }}
          data-testid="select-file"
        >
          <FileSelect
            file={file}
            toggleSelectDocument={toggleSelectDocument}
            selectedDocs={selectedDocs}
          />
        </div>
      )}
      {enableSelection && !isSelected && isHovered && (
        <div style={{ position: "absolute", left: "15px", top: "24px" }} data-testid={`file-preview-button-${file?.id || file?.ack_id}`}>
          <PreviewEyeIcon
            color="#576EC1"
            onClick={() => {
              handlePreview();
            }}
          />
        </div>
      )}
      {visible && (
        <Modal
          visible={visible}
          onCancel={closePreview}
          footer={null}
          width={800}
          style={{ height: 780 }}
          bodyStyle={{ height: 900, overflowY: "auto" }}
          title="Preview"
          destroyOnClose
        >
          {carouselItems.length > 0 && (
            <DocumentPreviewCarousel
              items={carouselItems}
              startIndex={carouselStartIndex}
              onPrint={onPrint}
              setIsPODemailModalVisible={setIsPODemailModalVisible}
              toggleSelectDocument={toggleSelectDocument}
              enableSelection={enableSelection}
            />
          )}
        </Modal>
      )}
    </div>
  );
};